import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PublicLicenseSearchComponent } from './public-license-search.component';

const licenseSearchRoutes: Routes = [
  { path: 'public-license-search', component: PublicLicenseSearchComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(licenseSearchRoutes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class LicenseSearchRoutingModule {
}
